import React, { useState } from 'react';
import DeviceDependentSettingForm from './DeviceDependentSettingForm';
import { withStyles } from '@material-ui/core';
import * as Yup from "yup";
import { Paper } from '@material-ui/core';
import { connect } from 'react-redux';
import * as actions from './store/deviceDependentSettingActions';
import { snackActions } from '../../sc-utilities/SnackBar';
import { BackButton, hasPermission } from '../../sc-utilities';
import History from "../../../History";

const styles = theme => ({
    root: {
        width: 'auto',
        height: 'auto',
        padding: theme.spacing(2),
        paddingRight: theme.spacing(6),
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            padding: 0,
            margin: 0,
            paddingRight: 0,
        }
    },
});

const DeviceDependentSettingsCreate = props => {
    const { permissions, activeCustomerID, translations, classes, onCreateDeviceDependentSettings } = props;
    const [settingNumber, setSettingNumber] = useState({
        settingNumber: [0],
        initialValues: {
            DependentType: '',
            Key_0: '',
            Value_0: ''
        },
        data: true
    });

    const handleSubmit = async data => {
        let objToSend = {}
        let dataToSend = {}
        for (var key in data) {
            if (key.includes('Key')) {
                let number = key.split('_')[1];
                if (settingNumber.settingNumber.includes(Number(number))) {
                    dataToSend[data[key]] = data[`Value_${number}`];
                    if (data[key] === '') {
                        return snackActions.snackBar({
                            message: 'Key cannot be empty!',
                            options: {
                                variant: 'warning'
                            }
                        }
                        );
                    }
                }
            }
        }
        objToSend['DependentType'] = data['DependentType'];
        objToSend['DependentSetting'] = JSON.stringify(dataToSend);
        let result = await onCreateDeviceDependentSettings({ ...objToSend, ActiveCustomerID: activeCustomerID });
        if (result) {
            History.goBack();
        }
    };

    let formSettings = {
        Validation: {
            DependentType: Yup.string().required("Required")
        },
        FormTitle: translations['new_dependent_setting'] || 'New dependent settings',
        ButtonSubmit: hasPermission(permissions, "device_dependent_setting_create") ? {
            Title: translations["save"] || "SAVE",
            Color: 'primary'
        } : null
    };
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <DeviceDependentSettingForm
                formSettings={formSettings}
                initialValues={settingNumber.initialValues}
                settingNumber={settingNumber}
                setSettingNumber={setSettingNumber}
                handleSubmit={handleSubmit}
                translations={translations}
            />
        </Paper>
    )
}

const mapStateToProps = state => {
    return {
        activeCustomerID: state.core.login.activeCustomer.CustomerID,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {},
        permissions: state?.core?.login?.permissions || [],
    };
};

const mapDispatchToProps = dispatch => {
    return {
        onCreateDeviceDependentSettings: deviceDependentSetting => dispatch(actions.createDependentSetting(deviceDependentSetting)),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles)(DeviceDependentSettingsCreate));
